export const ToggleOpen = () => {
	return (
		<svg
			width="12"
			height="6"
			viewBox="0 0 12 6"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.8026 0.186279C11.0184 0.376772 11.0184 0.713544 10.8026 0.904053L5.55945 5.53198L5.5155 5.57007L5.47156 5.53198L0.228394 0.904052C0.0126289 0.71354 0.0125868 0.376763 0.228394 0.186279C0.409316 0.0265907 0.68126 0.0265907 0.862183 0.186279L5.5155 4.2937L10.1688 0.186279C10.3497 0.0265995 10.6217 0.0266165 10.8026 0.186279Z"
				fill="#101010"
				stroke="white"
				strokeWidth="0.133333"
			/>
		</svg>
	);
};

export const ToggleClose = () => {
	return (
		<svg
			width="12"
			height="6"
			viewBox="0 0 12 6"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0.228455 5.47311C0.0126306 5.28262 0.0126534 4.94585 0.228455 4.75534L5.47162 0.127411L5.51556 0.089325L5.55951 0.127411L10.8027 4.75534C11.0184 4.94585 11.0185 5.28263 10.8027 5.47311C10.6218 5.6328 10.3498 5.6328 10.1689 5.47311L5.51556 1.36569L0.862244 5.47311C0.681331 5.63279 0.409377 5.63278 0.228455 5.47311Z"
				fill="#101010"
				stroke="white"
				strokeWidth="0.133333"
			/>
		</svg>
	);
};
